var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArmArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.100041 3.50166L4.55337 0.16166C5.08076 -0.233882 5.83337 0.142424 5.83337 0.80166V6.60166C5.83337 7.2609 5.08076 7.6372 4.55337 7.24166L0.100041 3.90166C-0.0332926 3.80166 -0.0332927 3.60166 0.100041 3.50166Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArmArrowBlack);
export default __webpack_public_path__ + "static/media/leftArmArrowBlack.bf9bddd45001deac9836d0b72f6f0a09.svg";
export { ForwardRef as ReactComponent };